module.exports = __webpack_public_path__ + "img/paxconnect.02561920.svg";